var _regeneratorRuntime = require("/home/runner/work/mzvast.github.io/mzvast.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/mzvast.github.io/mzvast.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

/** @ts-ignore */

/** @type {import('flexsearch')['default']} */
var FlexSearch = require("flexsearch");

var defaults = {
  path: '/poindexter.bundle.json'
};
module.exports.client = {
  index: null,
  fetch: function (_fetch) {
    function fetch(_x) {
      return _fetch.apply(this, arguments);
    }

    fetch.toString = function () {
      return _fetch.toString();
    };

    return fetch;
  }(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(path) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              path = path || defaults.path;

              if (!(typeof fetch === 'function')) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return fetch(path).then(function (res) {
                return res.json();
              });

            case 4:
              return _context.abrupt("return", _context.sent);

            case 7:
              return _context.abrupt("return", require(eval("require")('path').resolve(path)));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }()),
  init: function () {
    var _init = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _ref2,
          path,
          _ref3,
          config,
          dump,
          index,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _ref2 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : defaults, path = _ref2.path;
              _context2.next = 3;
              return this.fetch(path);

            case 3:
              _ref3 = _context2.sent;
              config = _ref3.config;
              dump = _ref3.dump;
              index = FlexSearch.create(config);
              index.import(dump, {
                serialize: false
              });
              this.index = index;
              return _context2.abrupt("return", index);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function init() {
      return _init.apply(this, arguments);
    }

    return init;
  }()
};